import React, { useState, useEffect, useCallback } from 'react';
import { Grid, Search } from 'semantic-ui-react';
import { SegmentContainer } from '../../global.styles';
import { searchRentals } from '../../firebase/functions';
import { useDebounce } from '../../hooks/useDebounce';
import { Helmet } from 'react-helmet';
import CollectionContainer from '../../components/collection-container/CollectionContainer';

const SearchPage = () => {
    
  const [results, setResults] = useState([]);
  const [data, setData] = useState();
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const debouncedSearchText = useDebounce(searchText, 600);

  const fetchRentals = useCallback(async () => {
    setLoading(true);
    const resultsArr = await searchRentals(debouncedSearchText);
    setData(resultsArr);
    const transformedResults = resultsArr?.map((data) => {
      return {
        title: data.name,
        description: data.description,
        image: data.image,
        price: `$${data.full_day_price}.00`,

      };
    });
    setResults(transformedResults);
    setLoading(false);
  }, [debouncedSearchText]);

  useEffect(() => {
    if (!debouncedSearchText) return;
    fetchRentals();
  }, [debouncedSearchText, fetchRentals]);

  const handleChange = (e, { value }) => {
    setSearchText(value);
  };

  return (
    <Grid centered>
      <Helmet>
        <title> Search rentals </title>
        <meta
          name='description'
          content='This is a search page for all rentals'
        />
      </Helmet>
      <Grid.Row>
        <Grid.Column width={16}>
          <SegmentContainer flex='true' flexend='true'>
            <Search
              aligned='right'
              results={results}
              size='big'
              onSearchChange={handleChange}
              loading={loading}
            />
          </SegmentContainer>
        </Grid.Column>
      </Grid.Row>
      <Grid.Column width={16}>
        <CollectionContainer
          path='/rentals'
          viewButton
          rentals={data}
          withRating
          columns={4}
        />
      </Grid.Column>
    </Grid>
  );
};

export default SearchPage;
